export default "__VITE_ASSET__52233fd9__"